import { fetcher } from 'src/config/request';
import { ProductEndpoints } from './endpoints';
export const ProductService = {
    async updateFreeSignup(subdomain, payload) {
        const response = await fetcher.post(ProductEndpoints.updateFreeSignup(subdomain), payload);
        return response.data;
    },
    async getFreeSignupStatus(subdomain) {
        const response = await fetcher.get(ProductEndpoints.getFreeSignupStatus(), {
            headers: {
                Club: subdomain
            }
        });
        return response.data;
    },
    async getOffer(productId) {
        const response = await fetcher.get(ProductEndpoints.getOffer(productId));
        return response.data;
    }
};
